import { render, staticRenderFns } from "./VolunteerActivities.vue?vue&type=template&id=7b972478&"
import script from "./VolunteerActivities.vue?vue&type=script&lang=js&"
export * from "./VolunteerActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports